import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import React from "react";
import AuditLogFilter from "../../components/administration/audit_logs/AuditLogFilter";
import { BrowserRouter } from "../../helpers/tixxt-router";
import { Wrapper as QueryClientProvider } from "../../helpers/queryClient";

// Connects to data-controller="audit-log--filter"
export default class extends Controller {
  connect() {
    this.root = createRoot(this.element);

    this.renderFilter();
  }

  renderFilter() {
    this.root.render(
      <BrowserRouter>
        <QueryClientProvider>
          <AuditLogFilter />
        </QueryClientProvider>
      </BrowserRouter>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
